module.exports = __webpack_public_path__ + "static/media/platinum-tank.0cadee72.png";